import React from 'react'
// import { CardDeck, Card } from 'react-bootstrap';

import techRecruitment_serv_img from '../../images/technical-recruitment.jpg'
import infraCloud_serv_img from '../../images/infrastracture-cloud-automation.jpg'
import dataCenter_serv_img from '../../images/data-center-service.jpg'
import softWeb_serv_img from '../../images/soft-web-solution.jpg'

const Card = ({ title, imgSrc, imgAltName, children }) => {
  return (
    <div className='card my-3'>
      <img src={imgSrc} className='card-img-top' alt={imgAltName} />
      <div className='card-body'>
        <h5 className='card-title'>{title}</h5>
        <p className='card-text'>{children}</p>
      </div>
    </div>
  )
}
const ServicesCard = () => {
  return (
    <div className='container'>
      <div className='card-deck'>
        <Card
          title={'Technical Recruitment'}
          imgSrc={techRecruitment_serv_img}
          imgAltName='technical recruitment'
          addFooter={false}
        >
          We are not headhunters, we are the matchmakers between Clients and
          candidates. We search for the best possible candidates across the
          globe for our valuable clients. We deliver the candidates in a shape
          that they can be productive for our clients. Full stack developers -
          Infrastructure/Cloud Engineers - DevOps - Database Engineers - Network
          Engineers
        </Card>
        <Card
          title='Infrastructure/Cloud automation and orchestration'
          imgSrc={infraCloud_serv_img}
          imgAltName={'infrastructure cloud automation'}
          addFooter='false'
        >
          We provide Server, Network, Storage, Backup, Monitoring and desktop
          support management for our clients. Our expert certified professionals
          do all kinds of troubleshooting and configuration related with your IT
          infrastructure. VMware - AWS Cloud solutions - Automation - Monitoring
          - Backup - Docker - Kubernetes - Openshift
        </Card>
      </div>
      <div className='card-deck'>
        <Card
          title={'Data Center Services'}
          imgSrc={dataCenter_serv_img}
          imgAltName='dataCenterServices'
          addFooter={false}
        >
          Starting from Racking-stacking, cabling, operations of smart hands,
          Server and network provisioning and many more.
        </Card>
        <Card
          title='Software and Web Solution'
          imgSrc={softWeb_serv_img}
          imgAltName={'software web services'}
          addFooter='false'
        >
          We transform your business process into an automated tool so that it
          can do continuous delivery according to our business needs. We have
          team experts with Java, .Net/C# and web technologies (frontend and
          backend). We provided hosted services for your software and we provide
          services/bug-fixing/customization/revision upgrading services for our
          software.
        </Card>
      </div>
    </div>
  )
}

export default ServicesCard
